/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    strong: "strong",
    h2: "h2",
    a: "a",
    span: "span",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "With Actions for Apple Watch, your tasks go with you, even when you don’t have access to your iPhone."), "\n", React.createElement(_components.p, null, "To get started, make sure your Apple Watch has the Actions app installed by opening the Watch app on your iPhone and checking Actions has ", React.createElement(_components.strong, null, "Show App on Apple Watch"), " turned on."), "\n", React.createElement(_components.p, null, "When you launch Actions for Apple Watch, your Lists will appear underneath the Schedule button."), "\n", React.createElement(_components.h2, {
    id: "to-add-an-action-on-apple-watch",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#to-add-an-action-on-apple-watch",
    "aria-label": "to add an action on apple watch permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "To add an Action on Apple Watch"), "\n", React.createElement(_components.ol, null, "\n", React.createElement(_components.li, null, "Tap on the desired List or Schedule"), "\n", React.createElement(_components.li, null, "Scroll to the bottom of the list and tap +"), "\n", React.createElement(_components.li, null, "Enter your Action details"), "\n"), "\n", React.createElement(_components.p, null, "You can also delete or complete an Action Card by tapping on the Card."), "\n", React.createElement(_components.h2, {
    id: "complications",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#complications",
    "aria-label": "complications permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Complications"), "\n", React.createElement(_components.p, null, "When creating an Apple Watch face, you can add Actions complications to show your next few scheduled Actions, the number of Actions remaining for today, or a quick launch button for the app."), "\n", React.createElement(_components.h2, {
    id: "force-sync",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#force-sync",
    "aria-label": "force sync permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Force Sync"), "\n", React.createElement(_components.p, null, "If your Actions appear out of date, you can force sync by scrolling to the bottom of the list selector and tapping the Force Sync button."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
